import * as React from "react";

interface ISwapButtonProps {
  height?: number | string;
  width?: number | string;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
}

export default class SwapButtonVertical extends React.PureComponent<
  ISwapButtonProps
> {
  render() {
    return (
      <button
        type="button"
        className={
          "prveo-btn-svg prveo-btn-svg-primary " + this.props.className
        }
        onClick={this.props.onClick}
      >
        <svg
          style={{ height: this.props.height, width: this.props.width }}
          viewBox="0 0 64 64"
        >
          <path d="m 38.293,10.293 0,39.172 -3.586,-3.586 c -0.781,-0.781 -2.047,-0.781 -2.828,0 -0.391,0.391 -0.586,0.902 -0.586,1.414 0,0.512 0.195,1.023 0.586,1.414 l 7,7 c 0.781,0.781 2.047,0.781 2.828,0 l 7,-7 c 0.781,-0.781 0.781,-2.047 0,-2.828 -0.781,-0.781 -2.047,-0.781 -2.828,0 l -3.586,3.586 0,-39.172 c 0,-1.104 -0.896,-2 -2,-2 -1.104,0 -2,0.896 -2,2 z" />
          <path d="m 26.293,54.293 0,-39.172 3.586,3.586 c 0.781,0.781 2.047,0.781 2.828,0 0.781,-0.78 0.781,-2.048 0,-2.828 l -7,-7 c -0.781,-0.781 -2.047,-0.781 -2.828,0 l -7,7 c -0.391,0.39 -0.586,0.902 -0.586,1.414 0,0.512 0.195,1.024 0.586,1.414 0.781,0.781 2.047,0.781 2.828,0 l 3.586,-3.586 0,39.172 c 0,1.104 0.896,2 2,2 1.104,0 2,-0.896 2,-2 z" />
        </svg>
      </button>
    );
  }
}
